// src/store/modules/pozitiveUplifts.js
import apiClient from '@/axios';
import { message } from 'ant-design-vue';

const state = {
  uplifts: [], // List of uplifts
};

const getters = {
  getUplifts: (state) => state.uplifts,
};

const mutations = {
  SET_UPLIFTS(state, data) {
    state.uplifts = data;
  },
};

const actions = {
  // Fetch all uplifts
  async fetchUplifts({ commit }) {
    try {
      const response = await apiClient.get("/admin/pozitive-uplifts");
      if (response.data) {
        // const uplifts = response.data.data.map((u) => ({
        //   id: u.id,
        //   from: Number(u.from),
        //   to: Number(u.to),
        //   uplift: Number(u.uplift),
        //   delete: false,
        // }));
        commit("SET_UPLIFTS", response.data);
        return response.data;
      }
    } catch (error) {
      console.error("Error fetching Pozitive Uplifts:", error);
    }
  },

  // Save uplifts (create/update/delete)
  async saveUplifts({ dispatch }, uplifts) {
    try {
      const response = await apiClient.post("/admin/pozitive-uplifts", {
        uplifts,
      });

      if (response.data.status) {
        message.success("Uplifts saved successfully");
        // Reload uplifts after save
        await dispatch("fetchUplifts");
      } else {
        message.error(response.data.message || "Failed to save uplifts");
      }

      return response.data;
    } catch (error) {
      console.error("Error saving uplifts:", error);
      message.error(error.response?.data?.message || "Failed to save uplifts");
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
